import {Booking, Reservation} from '../api/types';
import {Action, handleActions} from 'redux-actions';
import {
    BookingDetailsFetchedPayload,
    GuestBookingFetchedPayload,
    ReservationCreatedPayload, 
    VisitorBookingsFetchedPayload, 
    bookingDetailsFetched, 
    guestBookingFetched, 
    reservationCreated,
    visitorBookingsFetched,
} from '../action/bookingsEvents';
import {allTenantDependentDataCleared} from '../action/authenticationEvents';

export interface BookingsState {
    booking: Record<string, Booking>;
    bookings: Booking[];
    visitorBookings: Booking[];
    guestBooking: null | Booking;
    reservation: null | Reservation;
}

export const initialState: BookingsState = {
    booking: {},
    bookings: [],
    visitorBookings: [],
    guestBooking: null,
    reservation: null,
};

/* eslint-disable max-len */
export const reducer = handleActions<BookingsState, any>(
    {
        [bookingDetailsFetched.toString()]: (state = initialState, action: Action<BookingDetailsFetchedPayload>) => {
            if (!state) {
                return state;
            }            
            return {
                ...state,
                bookings: {
                    ...state.bookings,
                    ...action.payload.booking,
                },
                booking: Array.isArray(action.payload.booking) && action.payload.booking.length >= 1
                    ? action.payload.booking.reduce((acc, item) => {
                        acc[item.bookingNumber] = item;
                        return acc;
                    }, {
                        ...state.booking,
                    })
                    : !Array.isArray(action.payload.booking) 
                        ?
                        {
                            ...state.booking,
                            [action.payload.booking.bookingNumber]: action.payload.booking,
                        }
                        :
                        {},
            };
        },
        [visitorBookingsFetched.toString()]: (state = initialState, action: Action<VisitorBookingsFetchedPayload>) => {
            if (!state) {
                return state;
            }

            return {
                ...state,
                visitorBookings: action.payload.visitorBookings,
            };
        },
        [guestBookingFetched.toString()]: (state = initialState, action: Action<GuestBookingFetchedPayload>) => {
            return {
                ...state,
                guestBooking: action.payload.booking,
            };
        },
        [allTenantDependentDataCleared.toString()]: (state = initialState, action: Action<{}>) => {
            return {
                ...initialState,
            };
        },
        [reservationCreated.toString()]: (
            state,
            action: Action<ReservationCreatedPayload>,
        ): BookingsState => {
            return {
                ...state,
                reservation: action.payload.reservation,
            };
        },
    },
    initialState,
);
